import React, { Fragment, useEffect, useState } from 'react';
// import { NavLink } from 'react-router-dom';
import {
  Card,
  CardHeader,
  Nav,
  NavItem,
  Row,
  TabContent,
  TabPane,
  NavLink
} from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import {
  gAPI_Visitors_Conversations_list,
  aPI_Contacts_Tickets_list,
  aPI_Contacts,
} from '../../../../../constants/APIs';
import classnames from 'classnames';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { connect } from 'react-redux';
import TicketsPage from './ticketsPage';
import Conversations from './conversations';
import no_contact_tickets from './../../../../../assets/no_contact_tickets.png';
import IntlMessages from '../../../../../helpers/IntlMessages';
const style_css = `.nav-tabs .nav-link.active::before,.nav-tabs .nav-item.show .nav-link::before {
  top:auto !important;
  bottom: 0 !important;
}
.active{
  background-color:transparent;
}`;
function ContactDetails({
  contact,
  contactId,
  history,
  locale,
  propertyId,
  integrationData,
  featuresUrl,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('');
  const [conversations, setConversations] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [currentPage, setcurrentPage] = useState(1);
  const [selectedPageSize, setSelectedPageSize] = useState(50);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedIntegration, setSelectedIntegration] = useState();
  useEffect(() => {
    const callApi = async () => {
      if (integrationData !== undefined && integrationData.length > 0) {
        handleConversations(integrationData[0].channel, 0, 1);
        setActiveTab('website');
      } else {
        handleTickets();
        setActiveTab('ticket');
      }
    };
    callApi();
  }, [propertyId, integrationData]);

  useEffect(() => {
    const callApi = async () => {
      if (activeTab === 'ticket') handleTickets();
    };
    callApi();
  }, [activeTab]);

  const handleConversations = async (channel, pageSize, pageNumber) => {
    setConversations([]);
    setSelectedIntegration();
    let integrations = integrationData;
    const response = await AxiosAPI({
      method: 'POST',
      url: gAPI_Visitors_Conversations_list,
      data: {
        Visitors: contact?.visitorId,
        VisitorDate: contact?.firstActivityDate,
        IntegrationId:
          integrations.length > 0
            ? integrations.filter((f) => f.channel === channel).map((m) => m.id)
            : [],
        GroupId: getGroupID(),
        Search: '',
        PageSize: selectedPageSize + pageSize,
        PageNumber: pageNumber,
      },
    });
    if (
      response.data?.conversations &&
      response.data.conversations.length > 0
    ) {
      setConversations(response.data.conversations);
      setTotalItems(response.data.totalItems);
      setTotalPages(response.data.pageCount);
      setSelectedPageSize(selectedPageSize + pageSize);
      setSelectedIntegration(channel);
    } else {
      setSelectedIntegration(channel);
    }
  };

  const handleTickets = async (pageSize, pageNumber) => {
    setTickets([]);
    console.log(contact);
    const contactResponse = await AxiosAPI({
      method: 'get',
      url: `${aPI_Contacts_Tickets_list}/${contactId}`,
    });
    if (
      contactResponse.data?.tickets &&
      contactResponse.data.tickets.length > 0
    ) {
      setTickets(contactResponse.data.tickets);
    }
  };

  return (
    <Fragment>
      <CardHeader className="pl-0 pr-0">
        <style>{style_css}</style>
        <Nav
          tabs
          className="card-header-tabs ml-0 mr-0"
          style={{
            backgroundColor: 'white',
            border: '1px solid lightgray',
          }}
        >
          {integrationData.length > 0 ? (
            <NavItem className="text-center nav-width">
              <NavLink
                style={{
                  background: `${activeTab === 'website' ? 'white' : 'none'}`,
                  cursor: 'pointer',
                }}
                className={classnames({
                  active: activeTab === 'website',
                  'nav-link': true,
                })}
                onClick={() => {
                  setActiveTab('website');
                }}
                to="#"
              >
                <IntlMessages id="menu.conversations" />
              </NavLink>
            </NavItem>
          ) : null}
          <NavItem className="text-center nav-width">
            <NavLink
              style={{
                background: `${activeTab === 'ticket' ? 'white' : 'none'}`,
                cursor: 'pointer',
              }}
              className={classnames({
                active: activeTab === 'ticket',
                'nav-link': true,
              })}
              onClick={() => {
                setActiveTab('ticket');
              }}
              to="#"
            >
              <IntlMessages id="dashboards.tickets" />
            </NavLink>
          </NavItem>
        </Nav>
      </CardHeader>
      <TabContent activeTab={activeTab} className="">
        {integrationData.length > 0 && (
          <TabPane tabId="website" className="chat-app-tab-pane">
            {selectedIntegration !== undefined && (
              <Conversations
                selectedIntegration={selectedIntegration}
                conversations={conversations}
                selectedPageSize={selectedPageSize}
                totalItems={totalItems}
                totalPages={totalPages}
                currentPage={currentPage}
                handleConversations={handleConversations}
                integrationData={integrationData}
              ></Conversations>
            )}
          </TabPane>
        )}
        <TabPane tabId="ticket" className="chat-app-tab-pane">
          {tickets.length > 0 ? (
            <TicketsPage
              tickets={tickets}
              handleTickets={handleTickets}
              featuresUrl={featuresUrl}
            ></TicketsPage>
          ) : (
            <Card>
              <Colxx md="12" className=" text-center">
                <img
                  src={no_contact_tickets}
                  style={{ width: '40%' }}
                  alt="No Tickets"
                />
              </Colxx>
            </Card>
          )}
        </TabPane>
      </TabContent>
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};

export default connect(mapStateToProps, {})(ContactDetails);
